import { render } from "./TitleBar.vue?vue&type=template&id=49d5256f&ts=true"
import script from "./TitleBar.vue?vue&type=script&lang=ts"
export * from "./TitleBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__